import endpoints, { axios } from "../config/api";

function deleteTaskFromProjectTemplate(templateId: number, taskId: number) {
  return axios.delete(endpoints.projectTemplates.removeTask(templateId), {
    data: [taskId]
  });
}

export default deleteTaskFromProjectTemplate;
